import { Ranking } from '../../models/Ranking';

import './RankingCard.light.scss';
import './RankingCard.dark.scss';

interface Props {
  ranking: Ranking;
  isBest: boolean;
  showReasoningList?: boolean;
  children?: React.ReactNode;
}

export function RankingCard({
  ranking,
  isBest,
  children,
  showReasoningList
}: Props) {
  return (
    <li className={`ranking-card${isBest ? ' best' : ''}`}>
      <div className='ranking-card__row'>
        <div className='ranking-card__score-display'>{ranking.score}</div>
        <div className='ranking-card__score-details'>
          <div className='ranking-card__score-rating'>
            {isBest ? 'Best' : 'Possible'} match
          </div>
          <div className='ranking-card__model-name'>
            {ranking.model.acronym}
          </div>
          {(showReasoningList || isBest) && (
            <ul className='ranking-card__reasoning-list'>
              {ranking.reasonings.map((reasoning) => (
                <li
key={reasoning}
className='ranking-card__reasoning'>
                  {reasoning}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {children}
    </li>
  );
}
